import { useEffect } from "react";
import { check, setChannel } from "@crabnebula/plugin-ota-updater";
import { careEnvironment } from "@akina/config";
import { platform } from "@tauri-apps/plugin-os";
import { isApp } from "@akina/utils";
import { loggerService } from "@akina/infra";
import { AppError } from "@akina/infra/exceptions";

export function useCheckOverTheAirUpdates() {

  // Check for over-the-air updates once on mount
  useEffect(() => {
    if (!isApp) return;

    const checkForUpdates = async () => {
      try {
        const currentPlatform = platform();
        if (careEnvironment.environment === "dev") return;
        const channel_str = `over-the-air-${careEnvironment.environment}-${String(currentPlatform)}`;
        await setChannel(channel_str); // e.g. "over-the-air-staging-macos" or "over-the-air-staging-windows"

        const update = await check();
        if (update) {
          await update.apply();
          location.reload();
        }
      } catch (error) {
        loggerService.error(new AppError("FailedToCheckOTAUpdatesException", JSON.stringify(error))); // Don't block the app if update check fails
      }
    };
    checkForUpdates();
  }, []);
}
